const Cart_Icon_reducer = (state = 0, action) => {
  switch (action.type) {
    case "add":
      return state + 1;
    case "remove":
      if (state > 0) {
        return state - 1;
      }
      break;
    default:
      return state;
  }
};

export default Cart_Icon_reducer;
